import { useNavigate } from 'react-router-dom';
import { Col, Row } from "reactstrap"
import { ILinkDetails } from './NavigationBox';

export const NavigationDetail = ({ linkTitle, linkName, linkColorClassName, orderClassName, url }: ILinkDetails) => {
    const navigate = useNavigate();

    return (
        <Col lg={4} md={4} sm={12} xs={12} className="whatsNextLinkContainer" onClick={() => { navigate(url); }}>
            <Row>
                <Col className={`${orderClassName} whatsNextLinkMargin`}>
                    <Row>
                        <Col className="linkTitle">
                            <p>{linkTitle}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className={`${linkColorClassName} linkName`}>
                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.53578 12.0749L12.1758 6.43492L6.53578 0.794922L5.47292 1.85778L9.30435 5.68064L0.304353 5.68064V7.18064L9.30435 7.18064L5.47292 11.0121L6.53578 12.0749Z" fill="white" />
                            </svg>
                            <span>&nbsp;&nbsp;{linkName}</span>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    )
}